import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FuelType, VehicleStatusModel } from 'projects/Administration/src/app/business-entities/fuel-view-model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { CheckListBusinessService } from 'projects/Administration/src/app/business-services/check-list.service';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import { VehicleBusinessService } from 'projects/Administration/src/app/business-services/vehicle-service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { FeatureCode, ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Subscription } from 'rxjs';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { CustomPaggerService } from '../../../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { BrandViewModel } from '../../../../business-entities/brand-view-model';
import { BrandType, ModelType, OwnerType, VehicleListViewModel, VehicleModel, VehicleTransmission, VehicleType } from '../../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../../business-services/brand.service';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { UserRoleMenu } from 'projects/Administration/src/app/business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.css']
})
export class VehicleListComponent implements OnInit {
  @Input() IsSearch: boolean;
  @Input() EditVehicleId: number;
  @Input() EditLicensePlate: string;
  @Input() IsAddNewVehicle: boolean;
  @Input() isAddFromAppointment: boolean = false;
  @Input() vehicleDetails: any = null;
  @Input() FromWorkOrder: any = false;
  showVehicleEditForm: boolean; // ADDED
  customerId: number;
  contactId: string; //Customer Guid
  contactUniqueId: string = ''; //Customer Contact Unique Id for MG
  vehicleGuid: string; //Vehicle Guid
  popupCloseResult = false;
  customerName: string;
  customerNo: string;
  id:string;
  vehicleId: number = 0;
  isEditFromCustomer: boolean = false;
  vehicleForm: FormGroup;
  makeList: BrandType[] = [];
  makeName: string;
  modelList: ModelType[] = [];
  modelName: string;
  vehicletypeName: string;
  vehicleTypes: VehicleType[] = [];
  ownerTypeName: string;
  ownerTypeList: Array<SelectListItemViewModel>;
  vehicleTransmissionName: string;
  vehicleTransmissionList: VehicleTransmission[] = [];
  fueltypeName: string;
  fuels: FuelType[] = [];
  vehiclegroupName: string;
  vehicleStatusList: VehicleStatusModel[] = [];
  registrationFirstDate: string;
  registrationLastDate: string = "";
  inspectionNextDate: string = "";
  inspectionPrevDate: string = "";
  color: string = "";
  endDate: string;
  dropdownSettings = {};
  selectedItems = [];
  vehicleSource: string = "";
  mainVehicleSource: string;
  mainVehicleSourceId: number;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  vehicleList: VehicleListViewModel[] = [];
  vehicleListRaw: VehicleListViewModel[] = [];
  vehicleSub: Subscription;
  brandList: BrandViewModel[];
  licensePlateClass: string;
  searchVehicleDetails: VehicleListViewModel;
  responseResult: any;
  subscription : Subscription;
  features: Features[] = [];
  isView: boolean = false;
  isFormValid: boolean = false;
  dmsfeature: Features;
  isSearchFormValid: boolean = false;
  driveName: string;
  _clientName: string;
  vehicleStatusDefault: string = '';
  userRoleRightsDetails: UserRoleMenu;
  driveDropdownValue: any = [{
    name: 'LHD',
    value: 1
  },
  {
    name: 'RHD',
    value: 2
  }]
  constructor(private service: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
    private toaster: ToastrService,
    public pService: CustomPaggerService,
    private translate: TranslateService,
    private brandService: BrandService,
    private formBuilder: FormBuilder,
    private checkListService: CheckListBusinessService,
    private EditRentalCar: RentalCarService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private currentLanguageService: CurrentLanguage,
    private customerService: CustomerService,
    private userService: UserDataService,
    ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['licensePlateNo', 'companyModel', 'chassisNo', 'customerName'];
    this.pService.searchTerm = '';
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === ModuleNames.Vehicle);
    this._clientName = localStorage.getItem("Theme");
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500
    };
    this.endDate = Utility.GetFormattedDate(new Date());
    this.showVehicleEditForm = false;
    this.IsSearch = this.IsSearch ?? true;
    if (!this.IsSearch) {
      this.customerName = 'test';
      this.customerNo = "";
      this.customerId = 0;
      this.vehicleId = this.EditVehicleId;
      this.showVehicleEditForm = true;
    }
    else {
      this.customerName = this.service.customerName;
      this.customerNo = this.service.customerNo;
      this.customerId = this.service.customerId;
      this.contactId = this.service.contactId;
      this.contactUniqueId = this.service.contactUniqueId ?? '';
    }
    this.vehicleForm = this.formBuilder.group({
      licensePlate: ['', [Validators.required]],
      regno: ['', [Validators.required]],
      customerName: ['', [Validators.required]],
      ownerType: ['', [Validators.required]],
      vehicletype: [''],
      makeCode: ['', [Validators.required]],
      model: ['', [Validators.required]],
      fueltype: [''],
      vehiclegroup: [this.vehicleStatusDefault, [Validators.required]],
      chassisNo: ['', [Validators.required]],
      engineSerialNumber: [''],
      mchCode: [''],
      compliaceNumber: [''],
      year: ['', [Validators.required]],
      mileage: [''],
      remark: [''],
      registrationFirstDate: ['', [Validators.required]],
      registrationLastDate: [''],
      inspectionNextDate: [''],
      inspectionPrevDate: [''],
      color: [''],
      totalWeight: [''],
      vehicleTransmission: [''],
      curbWeight: [''],
      numberOfAxles: [''],
      axleWeightLimitFront: [''],
      axleWeightLimitRear: [''],
      tyreDimensionFront: [''],
      tyreDimensionRear: [''],
      tyreLoadIndexFront: [''],
      tyreLoadIndexRear: [''],
      tyreSpeedIndexFront: [''],
      tyreSpeedIndexRear: [''],
      noOfCylinder: [''],
      cylinderCapacity: [''],
      powerKW: [''],
      powerHP: [''],
      noOfDoors: [''],
      noOfSeats: [''],
      drive: [''],
      fourWD: [''],
      contactUniqueId: [''],
      isImported: ['']
    });
    this.GetAllOwnerType();
    this.GetVehicleTransmission();
    this.GetAllMake();
    this.GetAllVehicleTypes();
    this.GetAllFuelTypes();
    this.getFeatures();
    this.GetAllVehicleStatus();
    if (!this.IsSearch) {
      this.editVehicleDetails(this.vehicleId, 0);
      this.vehicleForm.controls.licensePlate.disable();
      this.vehicleForm.controls.regno.disable();
      this.vehicleForm.controls.ownerType.disable();
      this.vehicleForm.controls.chassisNo.disable();
      if(this.FromWorkOrder){
        this.isView = true;
      }
    }
    if(this.customerService.IsCustomerAddFromVehicle)
    {
      this.toggleVehicleEditFormFn();
    }
    this.vehicleForm.patchValue({
      customerName: this.customerName
    })

    this.vehicleForm.get('customerName').disable();
    if (this.IsAddNewVehicle) {
      if (this.vehicleDetails != null) {
        this.vehicleId = 0;
        this.showVehicleEditForm = true;
        if (!this.empty(this.vehicleDetails.chassisNo)) {
          this.vehicleForm.patchValue({
            licensePlate: this.vehicleDetails.chassisNo
          })

          this.dataFactorySearch(this.vehicleDetails.chassisNo);
        } else if (!this.empty(this.vehicleDetails.vehicleIdentificationNumber)) {
          this.vehicleForm.patchValue({
            licensePlate: this.vehicleDetails.vehicleIdentificationNumber
          })

          this.dataFactorySearch(this.vehicleDetails.vehicleIdentificationNumber);
        }
      }
    } else {
      this.getVehicleList(this.customerId, this.contactUniqueId);
    }
    this.vehiclegroupName = this.vehicleStatusDefault;
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
      })
    }
  }

  async GetAllOwnerType(): Promise<void> {
    await this.service.GetVehicleOwnerTypeDropdownList().then(data => {
      this.ownerTypeList = this.mapdealer(data.responseObject);

      if (!this.IsSearch) {
        this.ownerTypeList.forEach(x => {
          this.selectedItems.push(x);
        });
        this.vehicleForm.patchValue({
          ownerType: this.selectedItems,
        });
      }
    });
  }

  mapdealer(array: OwnerType[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.rowId
        single.text = element.ownerType

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async GetVehicleTransmission(): Promise<void> {
    await this.service.GetVehicleTransmissionDropdownList().then(data => {
      this.vehicleTransmissionList = data.responseObject;
    });
  }

  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
  }

  async onMakeSelected(make: string) {
    this.makeName = make;

    this.modelName = "";
    if (make?.trim()) {
      this.GetAllModel(make);
    } else {
      this.modelList = [];
    }
    this.cdr.detectChanges();
  }

  async GetAllModel(make: string): Promise<void> {
    await this.brandService.GetModelnoDropdownList(make).then(data => {
      this.modelList = data.responseObject;
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
    });
  }

  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuels = data.responseObject.result.slice();
    });
  }

  async GetAllVehicleStatus(): Promise<void> {
    await this.EditRentalCar.GetAllVehicleStatus().then(data => {
      this.vehicleStatusList = data.responseObject.result.slice();
      if(this.vehicleStatusList != null && this.vehicleStatusList.length > 0){
        let defaultValue = this.vehicleStatusList.filter(x=>x.isDefault);
        if(defaultValue.length > 0){
          this.vehicleStatusDefault = defaultValue[0].vehicleStatus;
          this.vehiclegroupName = this.vehicleStatusDefault;
        }
      }
      if (this.isAddFromAppointment) {
        this.vehicleForm.get('customerName').clearValidators();
        this.vehicleForm.get('ownerType').clearValidators();
        this.vehicleForm.get('ownerType').setErrors(null);
        this.vehicleSource = EnvSetting.ThirdPartyVehicleSource;
        this.vehicleForm.patchValue({
          licensePlate: this.vehicleDetails.plateNumber,
          regno: this.vehicleDetails.plateNumber,
          vehicletype: !this.empty(this.vehicleDetails.vehicleGroup)? this.vehicleDetails.vehicleGroup : "",
          makeCode: !this.empty(this.vehicleDetails.brandName) ? this.vehicleDetails.brandName : "",
          model: !this.empty(this.vehicleDetails.modelName) ? this.vehicleDetails.modelName : "",
          fueltype: !this.empty(this.vehicleDetails.fuelTypeText) ? this.vehicleDetails.fuelTypeText : "",
          vehiclegroup: this.vehicleStatusDefault,
          chassisNo:!this.empty(this.vehicleDetails.vehicleIdentificationNumber)? this.vehicleDetails.vehicleIdentificationNumber : "",
          engineSerialNumber: "",
          mchCode: "",
          compliaceNumber: !this.empty(this.vehicleDetails.complianceNumber) ? this.vehicleDetails.complianceNumber : "",
          year: !this.empty(this.vehicleDetails.modelYear) ? this.vehicleDetails.modelYear : 0,
          mileage: 0,
          registrationFirstDate: !this.empty(this.vehicleDetails.firstRegistrationDate) ? this.vehicleDetails.firstRegistrationDate : "",
          registrationLastDate: !this.empty(this.vehicleDetails.lastRegistrationDate) ? this.vehicleDetails.lastRegistrationDate : "",
          inspectionNextDate: !this.empty(this.vehicleDetails.nextInspectionDate) ? this.vehicleDetails.nextInspectionDate : "",
          inspectionPrevDate: !this.empty(this.vehicleDetails.previousInspectionDate) ? this.vehicleDetails.previousInspectionDate : "",
          color: !this.empty(this.vehicleDetails.colorText) ? this.vehicleDetails.colorText : "",
          totalWeight: !this.empty(this.vehicleDetails.totalWeight) ? this.vehicleDetails.totalWeight : 0,
          vehicleTransmission: !this.empty(this.vehicleDetails.transmission) ? this.vehicleDetails.transmission : "",
          curbWeight: !this.empty(this.vehicleDetails.curbWeight) ? this.vehicleDetails.curbWeight : 0,
          numberOfAxles: !this.empty(this.vehicleDetails.numberOfAxles) ? this.vehicleDetails.numberOfAxles : 0,
          axleWeightLimitFront: !this.empty(this.vehicleDetails.axleWeightLimit_Front) ? this.vehicleDetails.axleWeightLimit_Front : 0,
          axleWeightLimitRear: !this.empty(this.vehicleDetails.axleWeightLimit_Rear) ? this.vehicleDetails.axleWeightLimit_Rear : 0,
          tyreDimensionFront: !this.empty(this.vehicleDetails.tyreDimension_Front) ? this.vehicleDetails.tyreDimension_Front : "",
          tyreDimensionRear: !this.empty(this.vehicleDetails.tyreDimension_Rear) ? this.vehicleDetails.tyreDimension_Rear : "",
          tyreLoadIndexFront: !this.empty(this.vehicleDetails.tyreLoadIndex_Front) ? this.vehicleDetails.tyreLoadIndex_Front : "",
          tyreLoadIndexRear: !this.empty(this.vehicleDetails.tyreLoadIndex_Rear) ? this.vehicleDetails.tyreLoadIndex_Rear : "",
          tyreSpeedIndexFront: !this.empty(this.vehicleDetails.tyreSpeedIndex_Front)? this.vehicleDetails.tyreSpeedIndex_Front : "",
          tyreSpeedIndexRear: !this.empty(this.vehicleDetails.tyreSpeedIndex_Rear)? this.vehicleDetails.tyreSpeedIndex_Rear : "",
           powerKW:!this.empty(this.vehicleDetails.enginePower_KW) ? this.vehicleDetails.enginePower_KW : 0,
           powerHP:!this.empty(this.vehicleDetails.enginePower_HP) ? this.vehicleDetails.enginePower_HP : 0,
           noOfDoors:!this.empty(this.vehicleDetails.doors) ? this.vehicleDetails.doors : 0,
           isImported:!this.empty(this.vehicleDetails.imported) ? this.vehicleDetails.imported : false
        });
        this.vehicleGuid = this.vehicleDetails.vehicleId
        this.color = !this.empty(this.vehicleDetails.colorText) ? this.vehicleDetails.colorText : "";
      }else{
        this.vehicleForm.patchValue({
          vehiclegroup: this.vehicleStatusDefault
        });
      }
    });
  }

  async dataFactorySearch(vehicleNo: string) {
    this.spinner.show();
    let noVehicleFound = this.translate.instant("lblNoVehicleFound");
    await this.service.getVehicleFrmoDataFactoryByLicencePlateNo(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if(response?.responseObject == null || response?.responseObject[0]?.personDetail == null){
          this.toaster.error(noVehicleFound);
          this.spinner.hide();
        }
        if(response.responseObject[0]?.vehicles == null){
          this.vehicleDetails = null;
          this.toaster.error(noVehicleFound);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          this.vehicleId = 0;
          this.vehicleSource = EnvSetting.ThirdPartyVehicleSource;
          if (response.responseObject[0].vehicles != null && response.responseObject[0].vehicles.length > 0) {
            let result = response.responseObject[0].vehicles[0];
            this.vehicleGuid = response.responseObject[0].vehicles[0].vehicleId
            if (!this.empty(result.brandName)) {
              this.GetAllModel(result.brandName);
            }
            this.vehicleForm.patchValue({
              regno: result.plateNumber,
              vehicletype: !this.empty(result.vehicleGroup) ? result.vehicleGroup : "",
              makeCode: !this.empty(result.brandName) ? result.brandName : "",
              model: !this.empty(result.modelName)? result.modelName : "",
              fueltype: !this.empty(result.fuelTypeText) ? result.fuelTypeText : "",
              vehiclegroup: this.vehicleStatusDefault,
              chassisNo: !this.empty(result.vehicleIdentificationNumber) ? result.vehicleIdentificationNumber : "",
              engineSerialNumber: "",
              mchCode: "",
              compliaceNumber: !this.empty(result.complianceNumber) ? result.complianceNumber : "",
              year: !this.empty(result.modelYear) ? result.modelYear : 0,
              mileage: 0,
              registrationFirstDate: !this.empty(result.firstRegistrationDate) ? result.firstRegistrationDate : "",
              registrationLastDate: !this.empty(result.lastRegistrationDate) ? result.lastRegistrationDate : "",
              inspectionNextDate: !this.empty(result.nextInspectionDate) ? result.nextInspectionDate : "",
              inspectionPrevDate: !this.empty(result.previousInspectionDate) ? result.previousInspectionDate : "",
              color: !this.empty(result.colorText) ? result.colorText : "",
              totalWeight: !this.empty(result.totalWeight) ? result.totalWeight : 0,
              vehicleTransmission: !this.empty(result.transmission) ? result.transmission : "",
              curbWeight: !this.empty(result.curbWeight) ? result.curbWeight : 0,
              numberOfAxles: !this.empty(result.numberOfAxles) ? result.numberOfAxles : 0,
              axleWeightLimitFront: !this.empty(result.axleWeightLimit_Front) ? result.axleWeightLimit_Front : 0,
              axleWeightLimitRear: !this.empty(result.axleWeightLimit_Rear) ? result.axleWeightLimit_Rear : 0,
              tyreDimensionFront: !this.empty(result.tyreDimension_Front) ? result.tyreDimension_Front : "",
              tyreDimensionRear: !this.empty(result.tyreDimension_Rear) ? result.tyreDimension_Rear : "",
              tyreLoadIndexFront: !this.empty(result.tyreLoadIndex_Front) ? result.tyreLoadIndex_Front : "",
              tyreLoadIndexRear: !this.empty(result.tyreLoadIndex_Rear) ? result.tyreLoadIndex_Rear : "",
              tyreSpeedIndexFront: !this.empty(result.tyreSpeedIndex_Front) ? result.tyreSpeedIndex_Front : "",
              tyreSpeedIndexRear: !this.empty(result.tyreSpeedIndex_Rear) ? result.tyreSpeedIndex_Rear : "",
               powerKW:!this.empty(result.enginePower_KW) ? result.enginePower_KW : 0,
               powerHP:!this.empty(result.enginePower_HP) ? result.enginePower_HP : 0,
               noOfDoors:!this.empty(result.doors) ? result.doors : 0,
               isImported:!this.empty(result.imported) ? result.imported : false
            });
            this.color = !this.empty(result.colorText) ? result.colorText : "";
            this.disableFoundVehicle();
          }
        }
      }
    }, _error => {
      this.spinner.hide()
    });
  }

  async searchVehicle() {
    this.vehicleSource = "Manual";
    
    let licensePlate = this.customerService.VehicleNumber != null ? this.customerService.VehicleNumber : this.vehicleForm.get('licensePlate').value;
    if (this.empty(licensePlate)) {
      licensePlate = this.service.vinNo != null ? this.service.vinNo : this.vehicleForm.get('chassisNo').value;
      if (this.empty(licensePlate)){
        this.isSearchFormValid = true;
        return;
      }
    }
    this.isSearchFormValid = false;
    this.spinner.show();
    await this.service.getVehicleByLicencePlateNo(licensePlate).then((response) => {
      this.searchVehicleDetails = response.responseObject;
      this.vehicleGuid = this.searchVehicleDetails.id
      if (response.responseObject.errorCount === 1) {
        this.spinner.hide();
        this.vehicleId = 0;
        this.resetUnfoundVehicleDetails();
        this.enableFoundVehicle();
        let tpVehicleSearch = false;
        if (this.features && this.features.length > 0) {
          let feature = this.features.find(x => x.featureCode === FeatureCode.ThirdPartyAPI)?.isActive
          tpVehicleSearch = feature;
        }
        if(tpVehicleSearch){
          let modelHeadermsg = this.translate.instant("lblDataFactoryTitle");
          let modelBodymsg = this.translate.instant("lblDataFactoryBody");
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
            if (this.popupCloseResult) {
              this.dataFactorySearch(licensePlate);
            }
          });
        } else {
          let noVehicleFound = this.translate.instant("lblNoVehicleFound");
          this.toaster.error(noVehicleFound);
        }

        return;
      }
      this.id = this.searchVehicleDetails.id
      this.vehicleId = this.searchVehicleDetails.vehicleId;
      this.vehicleSource = this.searchVehicleDetails.vehicleSource;
      this.mainVehicleSource = this.searchVehicleDetails.sourceOfCreation;
      this.mainVehicleSourceId = this.searchVehicleDetails.sourceOfCreationId;
      this.GetAllModel(this.searchVehicleDetails.companyMakeCode);
      this.vehicleForm.patchValue({
        regno: this.searchVehicleDetails.licensePlate,
        vehicletype: this.searchVehicleDetails.vehicleType,
        makeCode: this.searchVehicleDetails.companyMakeCode,
        model: this.searchVehicleDetails.companyModel,
        fueltype: this.searchVehicleDetails.fuelType,
        vehiclegroup: this.searchVehicleDetails.vehicleGroup,
        chassisNo: this.searchVehicleDetails.chassisNo,
        engineSerialNumber: this.searchVehicleDetails.engineSerialNo,
        mchCode: this.searchVehicleDetails.mchCode,
        compliaceNumber: this.searchVehicleDetails.complianceNumber,
        year: this.searchVehicleDetails.year,
        mileage: this.searchVehicleDetails.mileage,
        remark: this.searchVehicleDetails.remark,
        registrationFirstDate: this.searchVehicleDetails.registrationDate,
        registrationLastDate: this.searchVehicleDetails.registrationLastDate,
        inspectionNextDate: this.searchVehicleDetails.inspectionNextDate,
        inspectionPrevDate: this.searchVehicleDetails.inspectionPrevDate,
        color: this.searchVehicleDetails.color,
        totalWeight: this.searchVehicleDetails.totalWeight,
        vehicleTransmission: this.searchVehicleDetails.transmission,
        curbWeight: this.searchVehicleDetails.curbWeight,
        numberOfAxles: this.searchVehicleDetails.numberOfAxles,
        axleWeightLimitFront: this.searchVehicleDetails.axleWeightLimit_Front,
        axleWeightLimitRear: this.searchVehicleDetails.axleWeightLimit_Rear,
        tyreDimensionFront: this.searchVehicleDetails.tyreDimension_Front,
        tyreDimensionRear: this.searchVehicleDetails.tyreDimension_Rear,
        tyreLoadIndexFront: this.searchVehicleDetails.tyreLoadIndex_Front,
        tyreLoadIndexRear: this.searchVehicleDetails.tyreLoadIndex_Rear,
        tyreSpeedIndexFront: this.searchVehicleDetails.tyreSpeedIndex_Front,
        tyreSpeedIndexRear: this.searchVehicleDetails.tyreSpeedIndex_Rear,
        noOfCylinder: this.searchVehicleDetails.noOfCylinder,
        cylinderCapacity: this.searchVehicleDetails.cylinderCapacity,
        powerKW: this.searchVehicleDetails.powerKW,
        powerHP: this.searchVehicleDetails.powerHP,
        noOfDoors: this.searchVehicleDetails.noOfDoors,
        noOfSeats: this.searchVehicleDetails.noOfSeats,
        drive: this.searchVehicleDetails.drive,
        fourWD: this.searchVehicleDetails.fourWD,
        contactUniqueId: this.searchVehicleDetails.contactUniqueId,
        isImported: this.searchVehicleDetails.isImported,

      });
      this.color = this.searchVehicleDetails.color;
      if (this.IsSearch) { //not from vehicle master.
        this.vehicleForm.controls.vehiclegroup.disable();
        this.disableFoundVehicle()
      }

      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });

  }

  disableFoundVehicle() {
    this.vehicleForm.controls.chassisNo.disable();
    this.vehicleForm.controls.regno.disable();
    this.vehicleForm.controls.vehicletype.disable();
    this.vehicleForm.controls.makeCode.disable();
    this.vehicleForm.controls.model.disable();
    this.vehicleForm.controls.fueltype.disable();

    this.vehicleForm.controls.chassisNo.disable();
    this.vehicleForm.controls.engineSerialNumber.disable();
    this.vehicleForm.controls.mchCode.disable();
    this.vehicleForm.controls.compliaceNumber.disable();
    this.vehicleForm.controls.year.disable();
    this.vehicleForm.controls.mileage.disable();
    this.vehicleForm.controls.registrationFirstDate.disable();
    this.vehicleForm.controls.registrationLastDate.disable();
    this.vehicleForm.controls.inspectionNextDate.disable();
    this.vehicleForm.controls.inspectionPrevDate.disable();
    this.vehicleForm.controls.color.disable();
    this.vehicleForm.controls.totalWeight.disable();
    this.vehicleForm.controls.vehicleTransmission.disable();
    this.vehicleForm.controls.curbWeight.disable();
    this.vehicleForm.controls.numberOfAxles.disable();
    this.vehicleForm.controls.axleWeightLimitFront.disable();
    this.vehicleForm.controls.axleWeightLimitRear.disable();
    this.vehicleForm.controls.tyreDimensionFront.disable();
    this.vehicleForm.controls.tyreDimensionRear.disable();
    this.vehicleForm.controls.tyreLoadIndexFront.disable();
    this.vehicleForm.controls.tyreLoadIndexRear.disable();
    this.vehicleForm.controls.tyreSpeedIndexFront.disable();
    this.vehicleForm.controls.tyreSpeedIndexRear.disable();
    this.vehicleForm.controls.powerKW.disable();
    this.vehicleForm.controls.powerHP.disable();
    this.vehicleForm.controls.noOfDoors.disable();
    this.vehicleForm.controls.remark.disable();
    this.vehicleForm.controls.isImported.disable();
    this.vehicleForm.controls.fourWD.disable();
  }
  enableFoundVehicle() {
    this.vehicleForm.controls.chassisNo.enable();
    this.vehicleForm.controls.regno.enable();
    this.vehicleForm.controls.ownerType.enable();
    this.vehicleForm.controls.vehicletype.enable();
    this.vehicleForm.controls.makeCode.enable();
    this.vehicleForm.controls.model.enable();
    this.vehicleForm.controls.fueltype.enable();
    this.vehicleForm.controls.vehiclegroup.enable();
    this.vehicleForm.controls.chassisNo.enable();
    this.vehicleForm.controls.engineSerialNumber.enable();
    this.vehicleForm.controls.mchCode.enable();
    this.vehicleForm.controls.compliaceNumber.enable();
    this.vehicleForm.controls.year.enable();
    this.vehicleForm.controls.mileage.enable();
    this.vehicleForm.controls.registrationFirstDate.enable();
    this.vehicleForm.controls.registrationLastDate.enable();
    this.vehicleForm.controls.inspectionNextDate.enable();
    this.vehicleForm.controls.inspectionPrevDate.enable();
    this.vehicleForm.controls.color.enable();
    this.vehicleForm.controls.totalWeight.enable();
    this.vehicleForm.controls.vehicleTransmission.enable();
    this.vehicleForm.controls.curbWeight.enable();
    this.vehicleForm.controls.numberOfAxles.enable();
    this.vehicleForm.controls.axleWeightLimitFront.enable();
    this.vehicleForm.controls.axleWeightLimitRear.enable();
    this.vehicleForm.controls.tyreDimensionFront.enable();
    this.vehicleForm.controls.tyreDimensionRear.enable();
    this.vehicleForm.controls.tyreLoadIndexFront.enable();
    this.vehicleForm.controls.tyreLoadIndexRear.enable();
    this.vehicleForm.controls.tyreSpeedIndexFront.enable();
    this.vehicleForm.controls.tyreSpeedIndexRear.enable();
    this.vehicleForm.controls.powerKW.enable();
    this.vehicleForm.controls.powerHP.enable();
    this.vehicleForm.controls.noOfDoors.enable();
    this.vehicleForm.controls.remark.enable();
    this.vehicleForm.controls.isImported.enable();
    this.vehicleForm.controls.fourWD.enable();
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  async SaveButtonEvent(isSaveAndClose){
    if(this._clientName === 'mg' && this.customerId <= 0 && this.IsSearch){
      await this.crmAddEditVehicle(isSaveAndClose);
    }else{
      await this.AddEditVehicle(isSaveAndClose);
    }
  }

  async crmAddEditVehicle(isSaveAndClose) {
    if (this._clientName === 'mg' && this.service.crmCustomerObj) {
      let errorMessage = this.translate.instant("lblErrorMessage");
      let WarningMessage = this.translate.instant("lblErrorWarningForValue");
      let successMessage = '';

      await this.customerService.crmAddEditCustomer(this.service.crmCustomerObj).then(res => {
        if (res.responseCode === Constant.SuccessResponseCode) {
          this.responseResult = res.responseObject;
          if (this.responseResult.isSuccess) {
            this.service.customerId = this.customerId = this.responseResult.retValue;
            this.service.customerNo = this.customerNo = this.responseResult.customerNo;
            this.service.customerName = this.customerName = this.service.crmCustomerObj?.fullName;
            successMessage = this.responseResult.resultMessage;
            this.toaster.success(successMessage);
            this.AddEditVehicle(isSaveAndClose);
          }
          else if (res.responseCode === Constant.InternalError) {
            let errormsg = this.translate.instant("lblInternalError");
            this.toaster.error(errormsg);
          }
          else if (res.responseCode === Constant.ResponseCode) {
            let errormsg = this.translate.instant("lblAlreadyAdded");
            this.toaster.warning(errormsg);
          }
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
        if (error.status === Constant.BadRequest) {
          this.toaster.warning(WarningMessage);
        }
        else {
          this.toaster.error(errorMessage);
        }
      });
    } 
    else {
      this.AddEditVehicle(isSaveAndClose);
    }
  }

  async AddEditVehicle(isSaveAndClose) {
    if (!this.vehicleForm.valid) {
      this.isFormValid = true;
      return;
    }
    this.isFormValid = false;

    let makeNameStr = "";
    if (this.makeList.filter(f => f.brandCode == this.vehicleForm.get('makeCode').value).length > 0) {
      makeNameStr = this.makeList.filter(f => f.brandCode == this.vehicleForm.get('makeCode').value)[0].brandName;
    } else {
      makeNameStr = this.vehicleForm.get('makeCode').value;
    }
    let modelNo = "";
    if (!this.empty(this.vehicleForm.get('model').value) && this.modelList.filter(f => f.description == this.vehicleForm.get('model').value).length > 0) {
      modelNo = this.modelList.filter(f => f.description == this.vehicleForm.get('model').value)[0].modelNo;
    }
    let fuleTypeId = 0;
    if (!this.empty(this.vehicleForm.get('fueltype').value)) {
      fuleTypeId = this.fuels.filter(f => f.fuelType.toLowerCase() == this.vehicleForm.get('fueltype').value?.toLowerCase())[0]?.id;
    }
    let vehicleTypeId = 0;
    if (!this.empty(this.vehicleForm.get('vehicletype').value)) {
      vehicleTypeId = this.vehicleTypes.filter(f => f.code.toLowerCase() == this.vehicleForm.get('vehicletype').value?.toLowerCase())[0]?.id;
    }
    let ownerTypeId = "";
    if (!this.empty(this.vehicleForm.get('ownerType').value)) {
      ownerTypeId = this.vehicleForm.get('ownerType').value.map(x => x.value).join(',')
    }

    let vehicleGroupId = 0;
    if (!this.empty(this.vehicleForm.get('vehiclegroup').value)) {
      vehicleGroupId = this.vehicleStatusList.filter(f => f.vehicleStatus == this.vehicleForm.get('vehiclegroup').value)[0].vehicleStatusId;
    }
    let model = '';
    model =  this.vehicleForm.get('model').value?.label ? this.vehicleForm.get('model').value?.label : this.vehicleForm.get('model').value
    let vehileInfo =
    {
      id : this.id,
      vehicleId: this.empty(this.vehicleId) ? 0 : this.vehicleId,
      licensePlate: this.vehicleForm.get('regno').value,
      engineSerialNo: this.vehicleForm.get('engineSerialNumber').value,
      companyMakeCode: this.vehicleForm.get('makeCode').value,
      companyModel: model,
      companyMakeName: makeNameStr,
      modelNo: modelNo,
      mchCode: this.empty(this.vehicleForm.get('mchCode').value) ? "" : this.vehicleForm.get('mchCode').value,
      registrationDate: null,
      color: this.empty(this.vehicleForm.get('color').value) ? "" : this.vehicleForm.get('color').value,
      year: this.empty(this.vehicleForm.get('year').value) ? 0 : parseInt(this.vehicleForm.get('year').value),
      mileage: this.empty(this.vehicleForm.get('mileage').value) ? 0 : parseInt(this.vehicleForm.get('mileage').value),
      remark: this.vehicleForm.get('remark').value,
      chassisNo: this.vehicleForm.get('chassisNo').value,
      fuelTypeId: fuleTypeId,
      vehicleTypeId: vehicleTypeId,
      sourceOfCreation: "Planner",
      complianceNumber: this.empty(this.vehicleForm.get('compliaceNumber').value) ? "" : this.vehicleForm.get('compliaceNumber').value,
      vehicleGroup: this.empty(this.vehicleForm.get('vehiclegroup').value) ? "" : this.vehicleForm.get('vehiclegroup').value,
      registrationLastDate: null,
      transmission: this.empty(this.vehicleForm.get('vehicleTransmission').value) ? "" : this.vehicleForm.get('vehicleTransmission').value,
      totalWeight: this.empty(this.vehicleForm.get('totalWeight').value) ? 0 : parseInt(this.vehicleForm.get('totalWeight').value),
      curbWeight: this.empty(this.vehicleForm.get('curbWeight').value) ? 0 : parseInt(this.vehicleForm.get('curbWeight').value),
      numberOfAxles: this.empty(this.vehicleForm.get('numberOfAxles').value) ? 0 : parseInt(this.vehicleForm.get('numberOfAxles').value),
      axleWeightLimit_Front: this.empty(this.vehicleForm.get('axleWeightLimitFront').value) ? 0 : parseInt(this.vehicleForm.get('axleWeightLimitFront').value),
      axleWeightLimit_Rear: this.empty(this.vehicleForm.get('axleWeightLimitRear').value) ? 0 : parseInt(this.vehicleForm.get('axleWeightLimitRear').value),
      tyreDimension_Front: this.empty(this.vehicleForm.get('tyreDimensionFront').value) ? "" : this.vehicleForm.get('tyreDimensionFront').value,
      tyreDimension_Rear: this.empty(this.vehicleForm.get('tyreDimensionRear').value) ? "" : this.vehicleForm.get('tyreDimensionRear').value,
      tyreLoadIndex_Front: this.empty(this.vehicleForm.get('tyreLoadIndexFront').value) ? "" : this.vehicleForm.get('tyreLoadIndexFront').value,
      tyreLoadIndex_Rear: this.empty(this.vehicleForm.get('tyreLoadIndexRear').value) ? "" : this.vehicleForm.get('tyreLoadIndexRear').value,
      tyreSpeedIndex_Front: this.empty(this.vehicleForm.get('tyreSpeedIndexFront').value) ? "" : this.vehicleForm.get('tyreSpeedIndexFront').value,
      tyreSpeedIndex_Rear: this.empty(this.vehicleForm.get('tyreSpeedIndexRear').value) ? "" : this.vehicleForm.get('tyreSpeedIndexRear').value,
      inspectionNextDate: null,
      inspectionPrevDate: null,
      customerId: this.customerId == null ? this.customerService.customerId : this.customerId,
      customerNo: this.customerNo == null ? this.customerService.CustomerNumber : this.customerNo,
      integrationWithDMS: false,
      ownerTypeId: ownerTypeId,
      moduleId: ModuleNames.Vehicle,
      fuelType: this.empty(this.vehicleForm.get('fueltype').value) ? "" : this.vehicleForm.get('fueltype').value,
      vehicleType: this.empty(this.vehicleForm.get('vehicletype').value) ? "" : this.vehicleForm.get('vehicletype').value,
      vehicleGroupId: vehicleGroupId,
      noOfCylinder: this.empty(this.vehicleForm.get('noOfCylinder').value) ? 0 : parseInt(this.vehicleForm.get('noOfCylinder').value),
      cylinderCapacity: this.empty(this.vehicleForm.get('cylinderCapacity').value) ? 0 : parseInt(this.vehicleForm.get('cylinderCapacity').value),
      powerKW: this.empty(this.vehicleForm.get('powerKW').value) ? 0 : parseInt(this.vehicleForm.get('powerKW').value),
      powerHP: this.empty(this.vehicleForm.get('powerHP').value) ? 0 : parseInt(this.vehicleForm.get('powerHP').value),
      noOfDoors: this.empty(this.vehicleForm.get('noOfDoors').value) ? 0 : parseInt(this.vehicleForm.get('noOfDoors').value),
      noOfSeats: this.empty(this.vehicleForm.get('noOfSeats').value) ? 0 : parseInt(this.vehicleForm.get('noOfSeats').value),
      drive: this.empty(this.vehicleForm.get('drive').value) ? 0 : parseInt(this.vehicleForm.get('drive').value),
      fourWD: this.empty(this.vehicleForm.get('fourWD').value) ? 0 : this.vehicleForm.get('fourWD').value,
      isImported: this.empty(this.vehicleForm.get('isImported').value) ? 0 : this.vehicleForm.get('isImported').value,
      realtimeDmsSyncVehicle: true,
      vehicleSource:this.vehicleSource,
      vehicleGuid: this.empty(this.vehicleGuid) ? '' : this.vehicleGuid,
      contactUniqueId: this.empty(this.vehicleForm.get('contactUniqueId').value) ? "" : this.vehicleForm.get('contactUniqueId').value
    }

    if (this.features && this.features.length > 0) {
      this.dmsfeature = this._clientName === 'mg' ?  this.features.find(x => x.featureCode === FeatureCode.CRM) : this.features.find(x => x.featureCode === FeatureCode.DMS);
      vehileInfo.integrationWithDMS = this.dmsfeature.isActive;
      let realTimeSync = this.features.find(x => x.featureCode === FeatureCode.RTDSV)?.isActive
      vehileInfo.realtimeDmsSyncVehicle = realTimeSync;
    }
    const temp = new Date();
    if (!this.empty(this.vehicleForm.get('registrationFirstDate').value)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.vehicleForm.get('registrationFirstDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
      vehileInfo.registrationDate = registerdate;
    } else {
      vehileInfo.registrationDate = "";
    }

    if (!this.empty(this.vehicleForm.get('registrationLastDate').value)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.vehicleForm.get('registrationLastDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
      vehileInfo.registrationLastDate = registerdate;
      if (vehileInfo.registrationDate > vehileInfo.registrationLastDate) {
        let errorMessage = this.translate.instant("lblRegLastDateHasToBeGreaterThanRegFirstDate");
        this.toaster.error(errorMessage);
        return;
      }
    } else {
      vehileInfo.registrationLastDate = "";
    }

    if (!this.empty(this.vehicleForm.get('inspectionNextDate').value)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.vehicleForm.get('inspectionNextDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
      vehileInfo.inspectionNextDate = registerdate;
    } else {
      vehileInfo.inspectionNextDate = "";
    }
    if (!this.empty(this.vehicleForm.get('inspectionPrevDate').value)) {
      let registerdate = new Date(Utility.getDateStringToDate(this.vehicleForm.get('inspectionPrevDate').value).getTime() - (temp.getTimezoneOffset() * 60000));
      vehileInfo.inspectionPrevDate = registerdate;
    } else {
      vehileInfo.inspectionPrevDate = "";
    }
    if (vehileInfo.inspectionNextDate && vehileInfo.inspectionPrevDate) {
      if (vehileInfo.inspectionPrevDate > vehileInfo.inspectionNextDate) {
        let errorMessage = this.translate.instant("lblInspNextDateHasToBeGreaterThanInspPrevDate");
        this.toaster.error(errorMessage);
        return;
      }
    }
    await this.SaveUpdateVehicle(vehileInfo, isSaveAndClose);
  }

  async SaveUpdateVehicle(vehileInfo: VehicleModel, isSaveAndClose) {
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    if (this.vehicleId == 0) {
      successMessage = this.translate.instant("lblVehicleAddedSuccessfully");
    } else {
      successMessage = this.translate.instant("lblVehicleUpdatedSuccessfully");
    }

    if (vehileInfo.ownerTypeId == "7") {
      let invalidPayer = this.translate.instant('lblInvalidPayer');
      this.toaster.error(invalidPayer);
      return;
    }
    this.spinner.show();
    await this.service.AddEditVehicle(vehileInfo).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.responseResult = res.responseObject;
        this.vehicleId =this.responseResult.retValue;
        if (this.responseResult.isSuccess) {
          this.toaster.success(successMessage);
          //SHOW GRID
          if (this.IsSearch && !this.isAddFromAppointment) {
            this.resetInputForm();
            this.showVehicleEditForm = !this.showVehicleEditForm;
            this.getVehicleList(this.customerId, this.contactUniqueId);
          }
          if (isSaveAndClose) {
            if(this.customerService.IsCustomerAddFromVehicle)
            {
             this.currentLanguageService.vehicleAdd.next(1);
            }
            this.activeModal.close({ success: true });
          }
          else
          {
            this.ngOnInit();
          }

        } else {
          if (this.responseResult.retValue == "-8000") {
            successMessage = this.translate.instant("lblAlreadyVehicleMapped");
          } else {
            successMessage = this.responseResult.resultMessage;

          }
          this.toaster.warning(successMessage);
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toaster.warning(errormsg);
      }
      this.spinner.hide();

    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toaster.warning(WarningMessage);
      }
      else {
        this.toaster.error(errorMessage);
      }
    });
  }

  get cpf() {
    return this.vehicleForm.controls;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }



  async getVehicleList(id, contactUniqueId) {
    this.spinner.show();
    await this.service.getVehicleByCustomerId(id, contactUniqueId ?? '', true).then((response) => {
      this.vehicleList = this.vehicleDataMapper(response.responseObject.result);
      this.vehicleListRaw = response.responseObject.result;
      if (this.vehicleList.length > 0) {
        this.showVehicleEditForm = false;
      } else {
        this.showVehicleEditForm = true;
      }

      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });
  }

  private vehicleDataMapper(vehicle: any) {
    let supperArray = [];
    if (vehicle && vehicle.length > 0) {

      for (let index = 0; index < vehicle.length; index++) {
        const element = vehicle[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.vehicleId = element.vehicleId
        single.licensePlate = element.licensePlate
        single.companyMakeName = element.companyMakeName
        single.companyMakeCode = element.companyMakeCode
        single.chassisNo = element.chassisNo
        single.color = element.color
        single.year = element.year
        single.registrationDate = element.registrationDate
        single.engineSerialNo = element.engineSerialNo
        single.fuelType = element.fuelType
        single.ownerType = element.ownerType
        single.vehicleGroup = element.vehicleGroup
        single.fromDate = element.fromDate
        single.logo = element.companyMakeCode;
        supperArray.push(single);
      }
    }
    return supperArray;
  }


  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }


  ngOnDestroy(): void {
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    if (this.vehicleSub) {
      this.vehicleSub.unsubscribe();
    }
    this.isFormValid = false;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    this.customerService.IsCustomerAddFromVehicle = false;
    this.customerService.VehicleNumber = null;
    this.customerService.CustomerId = null;
    this.customerService.CustomerNumber = null;
  }
  OnClose() {
    
    if(this.customerService.IsCustomerAddFromVehicle)
    {
      this.currentLanguageService.vehicleAdd.next(1);
      this.activeModal.close({ success: true });
    }
    else{
      this.activeModal.close({ success: false });
    }
    
  }

  @Output() backToFirstTab = new EventEmitter<any>();
  backToFirstTabFn() {
    this.backToFirstTab.emit();
  }

  // Show Vehicle Edit form
  toggleVehicleEditFormFn() {
    this.showVehicleEditForm = !this.showVehicleEditForm;
    this.isEditFromCustomer = !this.isEditFromCustomer;
    this.resetInputForm();
    this.isView = false;
    this.vehicleForm.controls.licensePlate.enable();
    this.enableFoundVehicle();
    this.vehiclegroupName = this.vehicleStatusDefault;
    if(this.customerService.IsCustomerAddFromVehicle)
    {
      this.vehicleForm.controls['licensePlate'].setValue(this.customerService.VehicleNumber);
      this.searchVehicle();
    }
  }
  CancelVehicle() {
    if (this.IsSearch) {
      this.showVehicleEditForm = !this.showVehicleEditForm;
      this.resetInputForm();
    }
  }

  editVehicleDetails(vehicleId: number, isView: number) {
    this.spinner.show();
    this.selectedItems = [];
    if (this.IsSearch) {
      let vehicleObj = this.vehicleListRaw.find(f => f.vehicleId == vehicleId);
      this.vehicleId = vehicleId;
      this.isEditFromCustomer = true;
      let ownType = vehicleObj?.ownerTypeId.split(',');
      if (this.ownerTypeList && ownType) {
        this.ownerTypeList.forEach(x => {
          ownType.forEach(y => {
            if (parseInt(x.value) == parseInt(y)) {
              this.selectedItems.push(x);
            }
          })
        })
      }
      this.vehicleForm.patchValue({
        licensePlate: vehicleObj.licensePlate,
        regno: vehicleObj.licensePlate,
        ownerType: this.selectedItems,
      });
      this.vehiclegroupName = vehicleObj.vehicleGroup;
      this.showVehicleEditForm = !this.showVehicleEditForm;
      if (isView === 1) {
        this.isView = true;
        this.vehicleForm.controls.licensePlate.disable();
        this.vehicleForm.controls.ownerType.disable();
        this.vehicleForm.controls.vehiclegroup.disable();
        this.disableFoundVehicle();
      }
    }
    else {
      if (this.ownerTypeList != undefined) {
        this.ownerTypeList.forEach(x => {
          this.selectedItems.push(x);
        });
        this.vehicleForm.patchValue({
          licensePlate: this.EditLicensePlate,
          regno: this.EditLicensePlate,
          ownerType: this.selectedItems,
        });
      } else {
        this.vehicleForm.patchValue({
          licensePlate: this.EditLicensePlate,
          regno: this.EditLicensePlate,
        });
      }


    }

    this.searchVehicle();
  }

  resetUnfoundVehicleDetails() {
    this.vehicleForm.controls.regno.reset();
    this.vehicleForm.controls.vehicletype.reset();
    this.vehicleForm.controls.makeCode.reset();
    this.vehicleForm.controls.model.reset();
    this.vehicleForm.controls.fueltype.reset();
    this.vehicleForm.controls.vehiclegroup.reset();
    this.vehicleForm.controls.chassisNo.reset();
    this.vehicleForm.controls.engineSerialNumber.reset();
    this.vehicleForm.controls.mchCode.reset();
    this.vehicleForm.controls.compliaceNumber.reset();
    this.vehicleForm.controls.year.reset();
    this.vehicleForm.controls.mileage.reset();
    this.vehicleForm.controls.registrationFirstDate.reset();
    this.vehicleForm.controls.registrationLastDate.reset();
    this.vehicleForm.controls.inspectionNextDate.reset();
    this.vehicleForm.controls.inspectionPrevDate.reset();
    this.vehicleForm.controls.color.reset();
    this.vehicleForm.controls.totalWeight.reset();
    this.vehicleForm.controls.vehicleTransmission.reset();
    this.vehicleForm.controls.curbWeight.reset();
    this.vehicleForm.controls.numberOfAxles.reset();
    this.vehicleForm.controls.axleWeightLimitFront.reset();
    this.vehicleForm.controls.axleWeightLimitRear.reset();
    this.vehicleForm.controls.tyreDimensionFront.reset();
    this.vehicleForm.controls.tyreDimensionRear.reset();
    this.vehicleForm.controls.tyreLoadIndexFront.reset();
    this.vehicleForm.controls.tyreLoadIndexRear.reset();
    this.vehicleForm.controls.tyreSpeedIndexFront.reset();
    this.vehicleForm.controls.tyreSpeedIndexRear.reset();
    this.vehicleForm.controls.powerKW.reset();
    this.vehicleForm.controls.powerHP.reset();
    this.vehicleForm.controls.noOfDoors.reset();
    this.vehicleForm.controls.fourWD.reset();
    this.vehicleForm.controls.isImported.reset();
  }

  resetInputForm() {
    this.vehicleId = 0;
    this.isEditFromCustomer = false;
    this.selectedItems = [];
    this.inspectionNextDate = "";
    this.inspectionPrevDate = "";
    this.color = "";
    this.vehicleForm.controls.licensePlate.reset();
    this.vehicleForm.controls.ownerType.reset();
    this.resetUnfoundVehicleDetails();

  }

  onChangeService(serviceId: any): void {
    if (serviceId == null) {
      this.selectedItems = [];
    } else {
      if (serviceId.length == 0) {
        this.selectedItems = [];
      }
    }
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  deleteVehicle(vehicleId, vin) {
    let vehileInfo =
    {
      vehicleId: vehicleId,
      customerId: this.customerId,
      customerNo: this.customerNo,
      chassisNo: vin,
      integrationWithDMS: false,
      moduleId: ModuleNames.Vehicle,
      ownerTypeId: 0,
      realtimeDmsSyncVehicle: true
    }

    if (this.features && this.features.length > 0) {
      let feature = this._clientName === 'mg' ?  this.features.find(x => x.featureCode === FeatureCode.CRM)?.isActive : this.features.find(x => x.featureCode === FeatureCode.DMS)?.isActive
      vehileInfo.integrationWithDMS = feature;
      let realTimeSync = this.features.find(x => x.featureCode === FeatureCode.RTDSV)?.isActive
      vehileInfo.realtimeDmsSyncVehicle = realTimeSync;
    }
    let modelHeadermsg = this.translate.instant("lblDeleteAssociation");
    let modelBodymsg = this.translate.instant("lblSureToDeleteAssociation");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.service.UnmapCustomerVehicle(vehileInfo).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode && response.responseObject) {
            let successMsg = this.translate.instant('lblVehicleUnmappedSuccess')
            this.toaster.success(successMsg);
            this.getVehicleList(this.customerId, this.contactUniqueId);
          } else {
            let errorMsg = this.translate.instant('lblErrorMessage');
            this.toaster.error(errorMsg);
          }
          this.spinner.hide();
        }).catch(err => {
          let errorMsg = this.translate.instant('lblErrorMessage');
          this.toaster.error(errorMsg);
          this.spinner.hide();
        });
      }
    });
  }
}
